export const DOMAIN_PAYGAP = "PAYGAP";
